import { useMemo } from "react";

import {
    setCurrentIframe,
    setCurrentIframeWrapper,
    setSelectedElement
} from "../services/stepThree";

const useIframesActions = () => useMemo(
    () => ({
        handleSetCurrentIframeRef: (iframe) => {
            setCurrentIframe(iframe);
        },
        handleSetCurrentIframeWrapperRef: (iframe) => {
            setCurrentIframeWrapper(iframe);
        },
        handleElementClick: (element) => {
            setSelectedElement(element);
        }
    }),
    [ ]
);

export default useIframesActions;
